import React from 'react';
import { Button, ButtonSize, ButtonVariant, YStack } from 'smoothie';

import { captureException } from '../../logger/Logger';

const ThrowError = () => {
    return (
        <YStack flex={1} alignItems="center" gap={24} padding={20}>
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Capture Exception"
                onPress={() => {
                    captureException(new Error('Dummy Captured Error'));
                }}
            />
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Throw Uncaught Error"
                onPress={() => {
                    throw new Error('Dummy Thrown Error');
                }}
            />
        </YStack>
    );
};

export default ThrowError;
